<template>
  <div class="computersTree">
    <treeselect
      v-model="selectedComputer"
      :multiple="multiple"
      :options="computersTree"
      :clearable="true"
      :open-on-click="true"
      :placeholder="placeholder"
      value-format="object"
      :default-expand-level="1"
      :normalizer="normalizer"
      :disable-branch-nodes="disabledFolder"
    />
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect';
  import { getComputers } from '@/api/methods/computers';
  import { TYPE_ITEM } from '@/utils/node-attributes';

  export default {
    components: {
      Treeselect,
    },
    props: ['multiple', 'disabledFolder'],
    data() {
      return {
        placeholder: this.$t('computers.userSelection'),
      };
    },
    computed: {
      computersTree() {
        return this.$store.getters['pageSpecificData/computersTree'] || [];
      },
      checkedComputerId() {
        return this.$store.getters['pageSpecificData/checkedComputerId'];
      },
      selectedComputer: {
        get() {
          return this.$store.getters['filters/selectedComputer'];
        },
        set(val) {
          val.checked = true;
          this.$store.commit('filters/setSelectedComputer', val);
        },
      },
    },
    async created() {
      if (!this.computersTree.length) await this.fetch();
      if (this.checkedComputerId) {
        const computer = this.findCompInTree(this.computersTree);
        computer.checked = true;
        this.$store.commit('filters/setSelectedComputer', computer);
      }
    },
    methods: {
      findCompInTree(tree) {
        return tree.reduce((found, item) => {
          if (found) return found;
          if (+item.id === +this.checkedComputerId) {
            return item;
          }

          if (item.type === TYPE_ITEM.FOLDER) {
            return this.findCompInTree(item.children || []);
          }

          return null;
        }, null);
      },
      normalizer(node) {
        let { name } = node;
        if (node.nameUser) name = node.nameUser;
        return {
          id: `${name}-${node.id}`,
          label: name,
        };
      },
      async fetch() {
        try {
          const data = await getComputers();
          this.$store.commit('pageSpecificData/setComputerData', data);
          this.$store.commit('pageSpecificData/setComputerTree', data.tree);
        } catch (err) {
          console.error(err);
        }
      },
    },
  };
</script>

<style lang="scss">
  .computersTree .vue-treeselect__control {
    border-radius: 0px;
  }
</style>
